var modules_77a29656 = {"wrapper":"_13zkypb","link":"_60tutm","btn":"_rca9gq"};
import "../../../assets/Povla9xo.css";

export { modules_77a29656 as default };
//# sourceMappingURL=reviews-action-block.module.scss.js.map
